import React from 'react';

import {deleteDocument} from 'app/folders/actions';
import {KBTreeDeleteItemModal} from 'app/kbs/components/KBEditPage/KBTree/KBTreeDeleteItemModal';
import {gt} from 'app/utils/i18n';
import {useAsyncActions} from 'app/utils/redux';

import type {ActionableDocumentType} from 'app/general/types';

interface Props {
  document: ActionableDocumentType;
  onClose: () => void;
  onSuccess: () => Promise<any>;
}

export function RemoveFromFolderModal({
  document,
  onClose,
  onSuccess,
}: Props): JSX.Element {
  const actions = useAsyncActions({deleteDocument});

  return (
    <KBTreeDeleteItemModal
      toDelete={{
        object: document,
        title: gt('Remove from folder'),
        icon: 'far fa-folder-minus',
        description: gt('Remove %s from this folder?', document.name),
        action: actions.deleteDocument,
        callback: onSuccess,
      }}
      onClose={onClose}
    />
  );
}
